const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const Element = require('../model/element.base')
const InputViewTypes = require('./input_view_types')
const LabelView = require('./label_view')
const template = require('./element.html')
const log = require('log').create('element_view') // eslint-disable-line
require('jquery-add-prefixed-class')


const ElementView = Marionette.View.extend({

    displayName: 'ElementView',
    tagName: 'fieldset',
    className: 'element',
    template,

    regions() {
        const regions = {
            input_region: '> .input-region',
        }

        if (this.options.model.get('show_label_before') || this.options.model.get('show_label_after')) {
            regions.label_region = '> .label-region'
        }
        if (
            this.options.model.get('show_confirmation')
            || this.options.model.get('show_error')
            || this.options.model.get('show_note')
        ) {
            regions.status_region = '> .status-region'
        }

        return regions
    },
    elementViewEvents: {
        'before:render': 'onBeforeElementRender',
        'render': 'onElementRender',
        'all': 'onAll',
    },
    elementModelEvents: {
        'change:label': 'showLabel',
        'change:confirmation': 'onChangeStatus',
        'change:error': 'onChangeStatus',
        'change:display_confirmations': 'onChangeStatus',
        'change:display_errors': 'onChangeStatus',
    },
    formModelEvents: {
        'change:display_confirmations': 'onChangeStatus',
        'change:display_errors': 'onChangeStatus',
    },

     
    constructor: function constructor(options = {}) {
        const model = options.model

        // validate model
        if (! (model instanceof Element)) throw new Error('ElementView requires an Element model.')

        // set type
        this.type = model.get('type')

        Marionette.View.call(this, options)

        Marionette.bindEvents(this, this, this.elementViewEvents)
        Marionette.bindEvents(this, model, this.elementModelEvents)

        this.form = options.form
        if (this.form) Marionette.bindEvents(this, this.form, this.formModelEvents)

        if (this.type === 'checkbox') {
            this.listenTo(this.model, 'change:checked', this.onCheckboxChangeChecked)
            this.listenTo(this, 'render', this.onCheckboxChangeChecked)
        }

    },

    onAll(event_name) {
        // log(event_name, arguments);
    },
    onBeforeElementRender() {

    },
    onElementRender() {
        const className = _.result(this, 'className')
        if (className) this.$el.addClass(className)
        this.$el.addPrefixedClass('type', this.type)
        if (_.contains(['submit', 'reset'], this.type)) {
            this.$el.addClass('type-button')
        }

        this.showLabel()
        this.onChangeStatus()
        this.createInputView()
    },
    createInputView() {
        const InputView = this.getInputView()
        this.input_view = new InputView({
            model: this.model,
        })
        this.showChildView('input_region', this.input_view)
    },
    getInputView() {
        const InputView = this.inputView || InputViewTypes[this.type]
        if (! InputView) throw new Error(`No InputView defined for type ${this.type}`)
        return InputView
    },

    showLabel() {
        const region = this.getRegion('label_region')
        if (! region) return

        const label = this.model.get('label')
        if (label) {
            const label_view = new LabelView({
                for: this.model.get('id'),
                label,
                className: this.model.get('label_class'),
            })
            region.show(label_view)
        } else {
            region.empty()
        }
    },

    onChangeStatus() {
        // evaluate error/confirmation status and update/remove label and classname
        const status = this.getStatus()

        switch (status) {
            case 'error':
                return this.showError()
            case 'confirmation':
                return this.showConfirmation()
            case 'note':
                return this.showNote()
            default:
                return this.emptyStatusRegion()
        }
    },

    getStatus() {
        const display_errors = (
            this.model.get('display_errors')
            && (this.form ? this.form.get('display_errors') : true)
        )
        const error = display_errors && this.model.get('error')
        if (error) return 'error'

        const display_confirmations = (
            this.model.get('display_confirmations')
            && (this.form ? this.form.get('display_confirmations') : true)
        )
        const confirmation = display_confirmations && this.model.get('confirmation')
        if (confirmation) return 'confirmation'

        const display_note = (
            this.model.get('display_note')
            && (this.form ? this.form.get('display_note') : true)
        )
        const note = display_note && this.model.get('note')
        if (note) return 'note'

        return undefined
    },

    getErrorClass() {
        const class_prefix = _.result(this, 'className')
        // if multiple error classnames are set (e.g. error glyph-attention)
        // only use the first one on the element itself
        const error_class = this.model.get('error_class').split(' ')[0].trim()
        return `${class_prefix}-${error_class}`
    },

    getConfirmationClass() {
        const class_prefix = _.result(this, 'className')
        // if multiple confirmation classnames are set (e.g. confirmation glyph-confirmation)
        // only use the first one on the element itself
        const confirmation_class = this.model.get('confirmation_class').split(' ')[0].trim()
        return `${class_prefix}-${confirmation_class}`
    },

    showError() {
        const error = this.model.get('error')
        const status_region = this.getRegion('status_region')

        if (status_region) {
            const error_view = new LabelView({
                for: this.model.get('id'),
                label: error,
                className: this.model.get('error_class'),
            })
            status_region.show(error_view)
        }
        this.$el.removeClass(this.getConfirmationClass())
        this.$el.addClass(this.getErrorClass())
    },

    showConfirmation() {
        const confirm = this.model.get('confirmation')
        const status_region = this.getRegion('status_region')

        if (status_region) {
            const confirm_view = new LabelView({
                for: this.model.get('id'),
                label: confirm,
                className: this.model.get('confirmation_class'),
            })
            status_region.show(confirm_view)
        }
        this.$el.removeClass(this.getErrorClass())
        this.$el.addClass(this.getConfirmationClass())
    },

    showNote() {
        const note = this.model.get('note')
        const status_region = this.getRegion('status_region')

        if (status_region) {
            const confirm_view = new LabelView({
                for: this.model.get('id'),
                label: note,
                className: this.model.get('note_class'),
            })
            status_region.show(confirm_view)
        }
        this.$el.removeClass(this.getErrorClass())
        this.$el.removeClass(this.getConfirmationClass())
    },

    emptyStatusRegion() {
        this.$el.removeClass(this.getConfirmationClass())
        this.$el.removeClass(this.getErrorClass())
        const status_region = this.getRegion('status_region')
        if (status_region) status_region.empty()
    },

    onCheckboxChangeChecked() {
        const checked = !! this.model.get('checked')
        this.$el.toggleClass('checked', checked)
    },

})

module.exports = ElementView
